
export default vm => {
  return [
    {
      labelWidth: 95,
      data: [
        {
          name: "所属机构",
          key: "organizationId",
          value: [],
          type: 4,
          isOrg: "",
          arr: [],
          clearable: true,
          async inputChange(value) {
            if(!value[0])return;
            vm.$http({
              url: `/buz/organizationGroup/queryTreeByOrgId?orgId=${value[0].id}`,
              type: "GET",
            }).then((res) => {              
              vm.formData[0].data[1].arr = vm.dealTree(res.data);
            });
          },
          rules: [
            {
              required: true,
              message: "请选择所属机构"
            }
          ]
        },
        {
          name: "所属团队",
          key: "groupId",
          value: [],
          type: 4,
          isOrg: "",
          arr: [],
          clearable: true,
          async inputChange(value) {
            if(!value[0])return;
            vm.$http({
              url: `/buz/userBase/getOnJobByGroup?groupId=${value[0].id}`,
              type: "GET",
            }).then((res) => {
              vm.formData[0].data[2].value = "";
              vm.formData[0].data[2].arr = res.data.map(item => {
                return {
                  label: item.name,
                  value: item.id
                }
              })
            });
          },
          rules: [
            {
              required: true,
              message: "请选择所属团队"
            }
          ]
        },
        {
          name: "所属业务员",
          key: "agentId",
          value: "",
          type: 2,
          clearable: true,
          rules: [
            {
              required: true,
              message: "请选择所属业务员"
            }
          ],
          arr: []
        }
      ],
    }
  ]
}